<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <orgsidebar></orgsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div v-if="pools!==null" class="moduleCard">
            <div class="row">
              <div class="col-4">
                License Pool to Transfer From:
              </div>
              <div class="col-8">
                <b-form-select v-model="fromPool" :options="pools" @change="updateProducts"></b-form-select>
              </div>
            </div>
            <div class="row mt-2" v-show="fromPool!==null&&products.length>0">
              <div class="col-4">
                Select A Product:
              </div>
              <div class="col-8">
                <select v-model="product" class="fullWidth" @change="productEntered">
                   <option v-for="pro in products" v-bind:value="pro.LicensePoolProductID">
                      {{pro.ProductExtendedName}}
                   </option>
                </select>
              </div>
            </div>
            <div class="row mt-2" v-show="product!==null" >
              <div class="col-4">
                License Pool to Transfer To:
              </div>
              <div class="col-8">
                <b-form-select v-model="toPool" :options="pools" @change="updatePoolData"></b-form-select>
              </div>
            </div>
            <div class="row mt-2" v-show="toPool!==null&&toPool!==fromPool&&product!==null">
               <div class="col-4">
                  &nbsp;
               </div>
               <div class="col-8">
                   Number available in source pool: {{poolData.NumberFrom}}<br />
                   Number available in target pool: {{poolData.NumberTo}}
               </div>
            </div>
            <div class="row mt-2" v-show="toPool!==null&&toPool!==fromPool&&product!==null">         
              <div class="col-4">
                Number of Licenses To Transfer:
              </div>
              <div class="col-8 text-left">
                <input type="number" class="ib" v-model.trim="numlicenses" />
              </div>
            </div>
            <div class="row mt-2" v-show="toPool!==null&&toPool!==fromPool&&product!==null">
               <div class="col-12">
                   <button class="btn btn-primary btn-short" @click="doTransfer">Do Transfer</button>
               </div>
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import orgsidebar from "../../layout/Organization/Sidebar.vue"

  export default {
    name: 'TransferLicenses',
    components:{acheader,acfooter,orgsidebar},
    data() {
      return {
         fromPool:null,
         numlicenses:0,
         product:null,
         products:[],
         toPool:null,
         pools:null,
         poolData:{
           NumberTo:0,
           NumberFrom:0
         }
      }
    },
    methods: {
      doTransfer() {
        if (this.numlicenses<1) {
          this.popDialog(1, "Please enter a valid number of licenses to transfer");
          return;
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "TransferLicenses",
            Fields: {
              FromLicensePoolID: this.fromPool,
              ToLicensePoolID: this.toPool,
              LicensePoolProductID: this.product,
              NumLicenses: this.numlicenses
            }
          }
        ]).then(r=> {
          var cr = JSON.parse(r.CommandResult);
          if (cr.returnObjects[0].returnObject==="OK") {
            this.popDialog(0,"Transfer complete");
            this.numlicenses=0;
            this.product=null;
            this.products=[];
            this.fromPool=null;
            this.toPool=null;
          }
          else {
            this.popDialog(1, cr.returnObjects[0].returnObject);
          }
        });
      },
      productEntered() {
        this.toPool=null;
      },
      updatePoolData() {
        var prid=null;
        this.poolData={
          NumberFrom: 0,
          NumberTo: 0
        }

        for(var prc of this.products.filter(p=>p.LicensePoolProductID===this.product)) {
          prid=prc.ProductID;
          this.poolData.NumberFrom=prc.LicensesNumber;
        }
        this.apiCommand([
         {
           Operation: "LicensePool",
           Function: "GetProducts",
           Fields: {
             LicensePoolID: this.toPool,
             LanguageID: sessionStorage.getItem("userLanguageID")
           }
         }
        ]).then(r=> {
          var cr=JSON.parse(r.CommandResult);
          var pr=JSON.parse(cr.returnObjects[0].returnObject);
          var prarr = pr.filter(p=>p.ProductID===prid);
         
          for(var pri of prarr) {
            this.poolData.NumberTo+=pri.LicensesNumber;
          }
     
        });
      },
      updateProducts() {
        this.product=null;
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetProducts",
            Fields: {
              LicensePoolID: this.fromPool,
              LanguageID: sessionStorage.getItem("userLanguageID")
            }
          }
        ]).then(r=> {
          var cr=JSON.parse(r.CommandResult);
          this.products=JSON.parse(cr.returnObjects[0].returnObject);
          this.products.unshift({
            LicensePoolProductID: null,
            ProductExtendedName:"--- Select ---"
          });
        });
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapOrg(this.$route.params.id);
        var pools=[{html:"--- Select ---", value:null}];
        for(var pool of this.sdata.allpools.filter(p=>p.OrganizationID===this.$route.params.id)) {
          pools.push({html:pool.LicensePoolName, value:pool.LicensePoolID});
        }
        this.pools=pools;
      });
    }
  }
</script>
